import { GridColDef } from "../../../Unknown/DataGrid";
import { AppointmentColumnItemStatus, AppointmentRowItem } from "../types";
import { DEFAULT_COLUMN_MIN_WIDTH } from "../../../../common/constants";

export type ColumnStatusTranslations = {
  columnStatus: string;
  statusCheckout: string;
  statusIncomplete: string;
  statusAbandoned: string;
  statusConfirmed: string;
  statusCanceled: string;
  statusIntakeComplete: string;
  statusCheckedIn: string;
  statusNoShow: string;
  statusStudiesUnread: string;
  statusStudiesRead: string;
  statusReportsSent: string;
  statusReportsError: string;
};

const getColumnStatus = (params: {
  columnItem: AppointmentColumnItemStatus;
  translations: ColumnStatusTranslations;
  valueOptions: { value: string; label: string }[];
}): GridColDef<AppointmentRowItem, string> => {
  const { columnItem, translations, valueOptions } = params;

  return {
    field: columnItem.field,
    headerName: translations.columnStatus,
    type: "singleSelect",
    valueOptions,
    flex: 0.5,
    minWidth: DEFAULT_COLUMN_MIN_WIDTH,
    valueGetter: ({ row }) => row.status,
  };
};

export default getColumnStatus;
